<template>
  <div>
    <view-options elementId="TheBusinessRegister" />
    <div class="product-view" id="TheBusinessRegister">
      <div>
        <div class="lds-ellipsis" v-if="Product.length === 0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <ad-goals
          v-bind:totalImpressions="Product.totalImpressions || 0"
          v-bind:totalClicks="Product.totalClicks || 0"
          :wording="wordings"
        ></ad-goals>

        <impressions
          :totalImpressions="Product.totalImpressions || 0"
          :yaxis="yaxis"
          :impressions="Product.impressions || []"
        ></impressions>
      </div>

      <product-look :productLook="productView"></product-look>

      <digital-presence
        v-if="digitalPresence.length"
        :digitalPresence="digitalPresence"
        :totalDigitalPresent="totalDigitalPresent"
        :googleResults="googleResults"
        :totalGoogle="totalGoogle"
      ></digital-presence>

      <ad-interactions
        v-if="adInteractions.length"
        :adInteractions="adInteractions"
      ></ad-interactions>

      <div class="widget ad-views" v-if="showAdsWidget">
        <h3 class="widget-title">
          Este es el desempeño de tus anuncios en
          {{ $route.params.productName }}
        </h3>
        <div class="cards-wrapper">
          <ad-listings
            :adListings="adListings"
            v-if="adListings.length > 0"
          ></ad-listings>
          <ad-banners
            :adsBanners="adsBanners"
            v-if="adsBanners.length > 0"
          ></ad-banners>
        </div>
      </div>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import AdGoals from "@/components/Widgets/AdGoals.vue";
import ProductLook from "@/components/Widgets/ProductLook.vue";
import Impressions from "@/components/Widgets/Impressions.vue";
import DigitalPresence from "@/components/Widgets/DigitalPresence.vue";
import AdInteractions from "@/components/Widgets/AdInteractions.vue";
import AdListings from "@/components/Widgets/YourAds/AdListings.vue";
import AdBanners from "@/components/Widgets/YourAds/AdBanners.vue";

// REQUEST
import { mapState, mapGetters } from "vuex";
import { ProductService } from "../../services/product.service";
import { GoogleSearchService } from "../../services/googlesearch.service";
import { PortalStatsService } from "../../services/portal-stats.service";
import { SubscriberService } from "../../services/subscriber.service";
import GoogelAnalytics from "../../services/google-analytics.service";
import { BR_BOOKCODE } from "../../constants";
import { validateProductExpirationDate } from "../../util";

export default {
  name: "amchamdr-online",
  components: {
    ViewOptions,
    AdGoals,
    ProductLook,
    Impressions,
    DigitalPresence,
    AdInteractions,
    AdListings,
    AdBanners
  },
  data() {
    return {
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      Product: [],
      totalDigitalPresent: {},
      totalGoogle: {},
      yaxis: {
        labels: {
          maxWidth: 80
        }
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      productView: {
        totalProductData: 0,
        sessions: 0,
        mobilePercentage: 0,
        desktopPercentage: 0
      },
      digitalPresence: [],
      googleResults: [],

      adListings: [],
      adInteractions: [],
      adsBanners: []
    };
  },
  computed: {
    ...mapGetters(["date1", "date2", "clientComercialNameStore"]),
    showAdsWidget() {
      return this.adListings.length > 0 || this.adsBanners.length > 0;
    }
  },
  methods: {
    ...mapState(["currentBusiness"])
  },
  watch: {
    date1: async function() {
      const { businessUnitId, subscriberId, productId } = this.$route.params;

      const products = this.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,this.$store.state.subscriber.date1)

      let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;
      const currentSubscriberId = this.$route.params.subscriberId;
      const bookCode = BR_BOOKCODE;
      const commercialName = this.clientComercialNameStore;

      const product = new ProductService(this).getProductGeneralStats(
        productId,
        subscriberId,
        toDate,
        fromDate,
        businessUnitId,
        bookCode,
        commercialName
      );
      const category = new ProductService(this).getCategoryStats(
        subscriberId,
        productId,
        toDate,
        fromDate
      );

      const googleResults = new GoogleSearchService(
        this
      ).GetGoogleCategoryStats({
        productId,
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        bookCode,
        commercialName
      });
      const itemsStats = new PortalStatsService(this).GetItemsStats({
        subscriberId,
        productId,
        fromDate,
        toDate
      });
      const adsBanners = new SubscriberService(this).getBanners({
        productId,
        subscriberId,
        businessUnitId
      });

      const subscriberListing = new SubscriberService(
        this
      ).getSubscriberListing(
        bookCode,
        parseInt(currentSubscriberId),
        businessUnitId
      );

      const endDate = new Date();

      let startDate = new Date();

      startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

      const GoogelAnalyticsService = new GoogelAnalytics(this);

      const googleAnalytics = GoogelAnalyticsService.getAnalytics(
        bookCode,
        businessUnitId,
        startDate,
        endDate
      );

      const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs(bookCode);

      Promise.all([
        googleAnalyticsSearchs,
        subscriberListing,
        category,
        googleAnalytics,
        product,
        googleResults,
        itemsStats,
        adsBanners
      ]).then(responses => {
        this.productView.sessions = Number(responses[3].sessions);
        this.productView.mobilePercentage = Number(
          responses[3].devicesPercentages.mobile
        );
        this.productView.desktopPercentage = Number(
          responses[3].devicesPercentages.desktop
        );
        this.productView.totalProductData = responses[3].pageViews;

        this.adListings = responses[1];
        this.digitalPresence = responses[2];
        this.productView.totalProductData = responses[3].total;
        this.Product = responses[4];
        this.googleResults = responses[5];
        this.adInteractions = responses[6];
        this.adsBanners = responses[7];

        //calculo digPresent

        let totalClicks = 0;
        let totalImpressions = 0;

        let totalClicksSum = 0;
        let totalImpressionsSum = 0;

        (responses[2].slice(0, 5) || []).forEach(response => {
          totalImpressions += parseInt(response.impressions);
          totalClicks += parseInt(response.clicks);
        });

        (responses[2].slice(5, 50) || []).forEach(response => {
          totalImpressionsSum += parseInt(response.impressions);
          totalClicksSum += parseInt(response.clicks);
        });

        let googleClickT = 0;
        let googleImpressionsT = 0;

        this.googleResults.forEach(resp => {
          googleClickT += parseInt(resp.clicks);
          googleImpressionsT += parseInt(resp.impressions);
        });

        let clickT = totalClicksSum + totalClicks;
        let impreT = totalImpressionsSum + totalImpressions;

        function commaSeparateNumber(amount, decimals = 0) {
          amount += ""; // por si pasan un numero en vez de un string
          amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

          decimals = decimals || 0; // por si la variable no fue fue pasada

          // si no es un numero o es igual a cero retorno el mismo cero
          if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

          // si es mayor o menor que cero retorno el valor formateado como numero
          amount = "" + amount.toFixed(decimals);

          var amount_parts = amount.split("."),
            regexp = /(\d+)(\d{3})/;

          while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(
              regexp,
              "$1" + "," + "$2"
            );

          return amount_parts.join(".");
        }

        const clickT1 = commaSeparateNumber(clickT);
        const impreT1 = commaSeparateNumber(impreT);

        const googleClickT1 = commaSeparateNumber(googleClickT);
        const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

        this.totalGoogle = { googleClickT1, googleImpressionsT1 };
        this.totalDigitalPresent = { clickT1, impreT1 };
      });
    },
    date2: async function() {
      const { productId, subscriberId, businessUnitId } = this.$route.params;
      const products = this.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,this.$store.state.subscriber.date1)

      let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;
      const currentSubscriberId = this.$route.params.subscriberId;
      const bookCode = BR_BOOKCODE;
      const commercialName = this.clientComercialNameStore;

      const product = new ProductService(this).getProductGeneralStats(
        productId,
        subscriberId,
        toDate,
        fromDate,
        businessUnitId,
        bookCode,
        commercialName
      );
      const category = new ProductService(this).getCategoryStats(
        subscriberId,
        productId,
        toDate,
        fromDate
      );

      const googleResults = new GoogleSearchService(
        this
      ).GetGoogleCategoryStats({
        productId,
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        bookCode,
        commercialName
      });
      const itemsStats = new PortalStatsService(this).GetItemsStats({
        subscriberId,
        productId,
        fromDate,
        toDate
      });
      const adsBanners = new SubscriberService(this).getBanners({
        productId,
        subscriberId,
        businessUnitId
      });

      const subscriberListing = new SubscriberService(
        this
      ).getSubscriberListing(
        bookCode,
        parseInt(currentSubscriberId),
        businessUnitId
      );

      const endDate = new Date();

      let startDate = new Date();

      startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

      const GoogelAnalyticsService = new GoogelAnalytics(this);

      const googleAnalytics = GoogelAnalyticsService.getAnalytics(
        bookCode,
        businessUnitId,
        startDate,
        endDate
      );

      const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs(bookCode);

      Promise.all([
        googleAnalyticsSearchs,
        subscriberListing,
        category,
        googleAnalytics,
        product,
        googleResults,
        itemsStats,
        adsBanners
      ]).then(responses => {
        this.productView.sessions = Number(responses[3].sessions);
        this.productView.mobilePercentage = Number(
          responses[3].devicesPercentages.mobile
        );
        this.productView.desktopPercentage = Number(
          responses[3].devicesPercentages.desktop
        );
        this.productView.totalProductData = responses[3].pageViews;

        this.adListings = responses[1];
        this.digitalPresence = responses[2];
        this.Product = responses[4];
        this.googleResults = responses[5];
        this.adInteractions = responses[6];
        this.adsBanners = responses[7];

        //calculo digPresent

        let totalClicks = 0;
        let totalImpressions = 0;

        let totalClicksSum = 0;
        let totalImpressionsSum = 0;

        (responses[2].slice(0, 5) || []).forEach(response => {
          totalImpressions += parseInt(response.impressions);
          totalClicks += parseInt(response.clicks);
        });

        (responses[2].slice(5, 50) || []).forEach(response => {
          totalImpressionsSum += parseInt(response.impressions);
          totalClicksSum += parseInt(response.clicks);
        });

        let googleClickT = 0;
        let googleImpressionsT = 0;

        this.googleResults.forEach(resp => {
          googleClickT += parseInt(resp.clicks);
          googleImpressionsT += parseInt(resp.impressions);
        });

        let clickT = totalClicksSum + totalClicks;
        let impreT = totalImpressionsSum + totalImpressions;

        function commaSeparateNumber(amount, decimals = 0) {
          amount += ""; // por si pasan un numero en vez de un string
          amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

          decimals = decimals || 0; // por si la variable no fue fue pasada

          // si no es un numero o es igual a cero retorno el mismo cero
          if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

          // si es mayor o menor que cero retorno el valor formateado como numero
          amount = "" + amount.toFixed(decimals);

          var amount_parts = amount.split("."),
            regexp = /(\d+)(\d{3})/;

          while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(
              regexp,
              "$1" + "," + "$2"
            );

          return amount_parts.join(".");
        }

        const clickT1 = commaSeparateNumber(clickT);
        const impreT1 = commaSeparateNumber(impreT);
        const googleClickT1 = commaSeparateNumber(googleClickT);
        const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

        this.totalGoogle = { googleClickT1, googleImpressionsT1 };
        this.totalDigitalPresent = { clickT1, impreT1 };
      });
    }
  },

  created: async function() {
    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    topFunction();

    const { productId, subscriberId, businessUnitId } = this.$route.params;
    const products = this.$store.state.subscriber.products;
    const validatedFinalDate = validateProductExpirationDate(products,productId,this.$store.state.subscriber.date1)

    let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
    let toDate = validatedFinalDate;
    const currentSubscriberId = this.$route.params.subscriberId;
    const bookCode = BR_BOOKCODE;
    const commercialName = this.clientComercialNameStore;

    const product = new ProductService(this).getProductGeneralStats(
      productId,
      subscriberId,
      toDate,
      fromDate,
      businessUnitId,
      bookCode,
      commercialName
    );
    const category = new ProductService(this).getCategoryStats(
      subscriberId,
      productId,
      toDate,
      fromDate
    );

    const googleResults = new GoogleSearchService(this).GetGoogleCategoryStats({
      productId,
      subscriberId,
      businessUnitId,
      toDate,
      fromDate,
      bookCode,
      commercialName
    });

    const itemsStats = new PortalStatsService(this).GetItemsStats({
      subscriberId,
      productId,
      fromDate,
      toDate
    });
    const adsBanners = new SubscriberService(this).getBanners({
      productId,
      subscriberId,
      businessUnitId
    });

    const subscriberListing = new SubscriberService(this).getSubscriberListing(
      bookCode,
      parseInt(currentSubscriberId),
      businessUnitId
    );

    const endDate = new Date();

    let startDate = new Date();

    startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

    const GoogelAnalyticsService = new GoogelAnalytics(this);

    const googleAnalytics = GoogelAnalyticsService.getAnalytics(
      bookCode,
      businessUnitId,
      startDate,
      endDate
    );

    const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs(bookCode);

    Promise.all([
      googleAnalyticsSearchs,
      subscriberListing,
      category,
      googleAnalytics,
      product,
      googleResults,
      itemsStats,
      adsBanners
    ]).then(responses => {
      this.productView.sessions = Number(responses[3].sessions);
      this.productView.mobilePercentage = Number(
        responses[3].devicesPercentages.mobile
      );
      this.productView.desktopPercentage = Number(
        responses[3].devicesPercentages.desktop
      );
      this.productView.totalProductData = responses[3].pageViews;

      this.adListings = responses[1];
      this.digitalPresence = responses[2];
      this.Product = responses[4];
      this.googleResults = responses[5];
      this.adInteractions = responses[6];
      this.adsBanners = responses[7];

      //calculo digPresent

      let totalClicks = 0;
      let totalImpressions = 0;

      let totalClicksSum = 0;
      let totalImpressionsSum = 0;

      (responses[2].slice(0, 5) || []).forEach(response => {
        totalImpressions += parseInt(response.impressions);
        totalClicks += parseInt(response.clicks);
      });

      (responses[2].slice(5, 50) || []).forEach(response => {
        totalImpressionsSum += parseInt(response.impressions);
        totalClicksSum += parseInt(response.clicks);
      });

      let googleClickT = 0;
      let googleImpressionsT = 0;

      this.googleResults.forEach(resp => {
        googleClickT += parseInt(resp.clicks);
        googleImpressionsT += parseInt(resp.impressions);
      });

      let clickT = totalClicksSum + totalClicks;
      let impreT = totalImpressionsSum + totalImpressions;

      function commaSeparateNumber(amount, decimals = 0) {
        amount += ""; // por si pasan un numero en vez de un string
        amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

        decimals = decimals || 0; // por si la variable no fue fue pasada

        // si no es un numero o es igual a cero retorno el mismo cero
        if (isNaN(amount) || amount === 0)
          return parseFloat(0).toFixed(decimals);

        // si es mayor o menor que cero retorno el valor formateado como numero
        amount = "" + amount.toFixed(decimals);

        var amount_parts = amount.split("."),
          regexp = /(\d+)(\d{3})/;

        while (regexp.test(amount_parts[0]))
          amount_parts[0] = amount_parts[0].replace(regexp, "$1" + "," + "$2");

        return amount_parts.join(".");
      }

      const clickT1 = commaSeparateNumber(clickT);
      const impreT1 = commaSeparateNumber(impreT);
      const googleClickT1 = commaSeparateNumber(googleClickT);
      const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

      this.totalGoogle = { googleClickT1, googleImpressionsT1 };
      this.totalDigitalPresent = { clickT1, impreT1 };
    });
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
@include respond-above(md) {
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.digital-presence,
      &.google-results,
      &.ad-interactions {
        grid-column: 1 / -1;
      }
    }
    .ad-views {
      grid-column: 1 / -1;
    }
  }
}
</style>
